import { render, staticRenderFns } from "./KucunManagementOperation.vue?vue&type=template&id=61b35638&scoped=true&"
import script from "./KucunManagementOperation.vue?vue&type=script&lang=js&"
export * from "./KucunManagementOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b35638",
  null
  
)

export default component.exports